export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban_04.0afd40b5.jpg";